import css from 'styled-jsx/css';
import { colorPalette, serif } from 'styles/css-constants';
import { warmGrays } from 'styles/colors/constants';
import {
  MQ_MEDIUM,
  MQ_MEDIUM_ONLY,
  MQ_LARGE,
  MQ_LARGE_ONLY,
  MQ_MIDLARGE
} from 'constants/mq';

export default css`
  :global(.with-open-nav) {
    position: fixed;
  }

  .SiteHeaderNav {
    display: flex;
    justify-content: space-around;
    list-style: none;
  }

  .SiteHeaderNav__block {
    margin-bottom: 1.5rem;
  }

  .SiteHeaderNav__block-heading,
  .SiteHeaderNav__featuresHeading {
    margin: 0 0 0.5rem;
    padding: 0;
    color: ${warmGrays[7]};
    font-size: var(--fontScaleNeg1);
    font-weight: bold;
  }

  .SiteHeaderNav__block-link {
    color: ${warmGrays[7]};
    font-size: var(--fontScaleNeg2);
    line-height: 1.9;
  }

  .SiteHeaderNav__block-links {
    list-style: none;
  }

  .SiteHeaderNav__block-text {
    color: ${warmGrays[7]};
    font-size: var(--fontScaleNeg1);
    line-height: 1.45;
  }

  .SiteHeaderNav__close-flyout {
    flex: 1 0 auto;
    display: flex;
    align-items: flex-end;
    justify-content: center;
  }

  .SiteHeaderNav__close-flyout button {
    margin-top: 1.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    color: ${warmGrays[7]};
    font-size: var(--fontScaleNeg3);
    letter-spacing: 0.05em;
    text-align: center;
    text-transform: uppercase;
  }

  .SiteHeaderNav__feature {
    display: block;
  }

  .SiteHeaderNav__feature :global(.SiteHeaderNav__featureImage) {
    width: 100%;
  }

  .SiteHeaderNav__featuresBlock {
    border-bottom: 1px solid ${warmGrays[0]};
    padding-bottom: 1.5rem;
  }

  .SiteHeaderNav__featuresBlock--1
    :global(.SiteHeaderNav__featureImage--narrow) {
    display: none;
  }

  .SiteHeaderNav__featuresBlock--3 {
    display: flex;
    flex-wrap: wrap;
  }

  .SiteHeaderNav__featuresBlock--3 .SiteHeaderNav__feature {
    flex: 0 0 33.33%;
  }

  .SiteHeaderNav__featuresBlock--3 .SiteHeaderNav__feature:nth-child(2) {
    padding-right: 0.5rem;
  }

  .SiteHeaderNav__featuresBlock--3 .SiteHeaderNav__feature:nth-child(3) {
    padding-right: 0.25rem;
    padding-left: 0.25rem;
  }

  .SiteHeaderNav__featuresBlock--3 .SiteHeaderNav__feature:last-child {
    padding-left: 0.5rem;
  }

  .SiteHeaderNav__featuresBlock--3 .SiteHeaderNav__featuresHeading {
    flex: 0 0 100%;
  }

  .SiteHeaderNav__featuresBlock--3 :global(.SiteHeaderNav__featureImage--wide) {
    display: none;
  }

  .SiteHeaderNav__featuresHeading {
    font-size: var(--baseFontSize);
    text-align: center;
  }

  .SiteHeaderNav__flyout {
    position: fixed;
    left: 0;
    display: none;
    flex-direction: column;
    justify-content: flex-start;
    width: 100%;
    height: calc(100% - 63px);
    padding: 1rem;
    background-color: #fff;
    border-top: 1px solid ${warmGrays[0]};
    overflow-y: auto;
  }

  .SiteHeaderNav__flyout--active {
    display: flex;
  }

  .SiteHeaderNav__item {
    flex: 1 0 auto;
  }

  .SiteHeaderNav__item::before {
    content: '';
    float: right;
    width: 1px;
    height: calc(100% - 0.75rem);
    background-color: ${warmGrays[0]};
    margin: 0.375rem 0;
  }

  .SiteHeaderNav__item:last-child::before {
    content: none;
  }

  .SiteHeaderNav__item:nth-child(n + 4) {
    display: none;
  }

  .SiteHeaderNav__item:last-child,
  .SiteHeaderNav__item:nth-last-child(2) {
    display: block;
  }

  .SiteHeaderNav__item:hover .SiteHeaderNav__link::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    display: block;
    height: 2px;
    width: 100%;
    background-color: ${colorPalette.brand};
  }

  .SiteHeaderNav__item--active .SiteHeaderNav__link::after {
    background-color: ${colorPalette.brand};
  }

  .SiteHeaderNav__link {
    flex: 1 0 auto;
    position: relative;
    display: block;
    padding: 0.5rem 0;
    color: ${warmGrays[7]};
    font-size: var(--fontScaleNeg3);
    letter-spacing: 0.02em;
    text-align: center;
    text-decoration: none;
    text-transform: uppercase;
  }

  .SiteHeaderNav__more-links {
    margin-bottom: 1.5rem;
    border-bottom: 1px solid ${warmGrays[0]};
  }

  .SiteHeaderNav__more-links {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-column-gap: 1rem;
  }

  .SiteHeaderNav__recirc {
    display: none;
  }

  .SiteHeaderNav__social-link {
    margin-right: 0.5rem;
    color: ${warmGrays[7]};
    font-size: 1rem;
  }

  .SiteHeaderNav__social-links {
    margin-bottom: 1.75rem;
    display: flex;
  }

  .SiteHeaderNav__user {
    margin-right: 1rem;
    font-size: 20px;
  }

  .SiteHeaderNav__user :global(a) {
    color: ${warmGrays[5]};
  }

  .SiteHeaderNav__networkBlock {
    padding-bottom: 1.5rem;
  }

  .SiteHeaderNav :global(.SiteHeaderNav__xsite-logo) {
    margin: 1rem 0 0.25rem;
    display: block;
  }

  :global(.at .SiteHeaderNav__xsite-logo) {
    max-width: 136px;
  }

  :global(.k .SiteHeaderNav__xsite-logo) {
    max-width: 250px;
  }

  .SiteHeaderNav :global(.SiteHeaderNavBlock) {
    margin-bottom: 1rem;
  }

  @media ${MQ_MEDIUM_ONLY} {
    .SiteHeaderNav__featuresBlock--3 {
      justify-content: center;
    }

    .SiteHeaderNav__featuresBlock--3 .SiteHeaderNav__feature {
      flex: 0 0 auto;
    }

    .SiteHeaderNav__feature :global(.SiteHeaderNav__featureImage) {
      width: auto;
    }
  }

  @media ${MQ_MEDIUM} {
    :global(.with-open-nav) {
      position: static;
    }

    .SiteHeaderNav__close-flyout {
      display: none;
    }

    .SiteHeaderNav__feature {
      display: flex;
      justify-content: center;
    }

    .SiteHeaderNav__flyout {
      position: absolute;
      /* Magic number for MacOS <Safari 12 */
      top: 70px;
    }

    .SiteHeaderNav__flyout--active {
      height: auto;
      padding: 1.5rem;
      box-shadow: 0 6px 6px rgba(0, 0, 0, 0.2);
    }

    .SiteHeaderNav__item:nth-last-child(2) {
      display: block;
    }
  }

  @media ${MQ_LARGE_ONLY} {
    .SiteHeaderNav__featuresBlock--1
      :global(.SiteHeaderNav__featureImage--narrow) {
      display: block;
    }

    .SiteHeaderNav__featuresBlock--1
      :global(.SiteHeaderNav__featureImage--wide) {
      display: none;
    }

    .SiteHeaderNav__featuresBlock--3 .SiteHeaderNav__feature {
      margin-bottom: 1rem;
      flex: 0 0 100%;
    }

    .SiteHeaderNav__featuresBlock--3 .SiteHeaderNav__feature:nth-child(2),
    .SiteHeaderNav__featuresBlock--3 .SiteHeaderNav__feature:nth-child(3),
    .SiteHeaderNav__featuresBlock--3 .SiteHeaderNav__feature:last-child {
      padding: 0;
    }

    .SiteHeaderNav__featuresBlock--3
      :global(.SiteHeaderNav__featureImage--narrow) {
      display: none;
    }

    .SiteHeaderNav__featuresBlock--3
      :global(.SiteHeaderNav__featureImage--wide) {
      display: block;
      width: 100%;
    }
  }

  @media ${MQ_LARGE} {
    .SiteHeaderNav__block-link {
      font-size: var(--fontScaleNeg1);
    }

    .SiteHeaderNav__block-heading,
    .SiteHeaderNav__featuresHeading {
      font-size: var(--baseFontSize);
    }

    .SiteHeaderNav__featuresBlock {
      flex: 1 0 calc(120px + 2rem);
      margin-right: 2rem;
      margin-bottom: 0;
      border-right: 1px solid ${warmGrays[0]};
      border-bottom: none;
      padding-right: 2rem;
    }

    .SiteHeaderNav__flyout {
      /* Magic number for MacOS <Safari 12 */
      top: 80px;
    }

    .SiteHeaderNav__flyout--active {
      flex-direction: row;
      justify-content: center;
      padding: 2rem;
    }

    .SiteHeaderNav__flyout--active.SiteHeaderNav__flyout--more {
      grid-template-columns: max-content 250px 250px;
    }

    .SiteHeaderNav__item:nth-child(n + 4) {
      display: block;
    }

    .SiteHeaderNav__link {
      font-size: var(--fontScaleNeg2);
    }

    .SiteHeaderNav__more-links,
    .SiteHeaderNav__networkBlock {
      margin-bottom: 0;
      border-bottom: none;
    }

    .SiteHeaderNav__more-links .SiteHeaderNav__block {
      margin-bottom: 0;
      width: 160px;
    }

    .SiteHeaderNav__networkBlock {
      flex: 0 1 360px;
      padding-left: 2rem;
      border-left: 1px solid ${warmGrays[0]};
    }

    .SiteHeaderNav__recirc {
      flex: 0 1 auto;
      display: grid;
      grid-template-columns: repeat(2, fit-content(320px));
      grid-column-gap: 1.5rem;
      align-items: start;
      border-left: 1px solid ${warmGrays[0]};
      padding-left: 2rem;
    }

    .SiteHeaderNav__recirc--2 {
      display: none;
    }

    .SiteHeaderNav__recirc-heading {
      margin-bottom: 1rem;
      color: ${warmGrays[7]};
      font-weight: bold;
    }

    .SiteHeaderNav__recirc-link {
      margin-bottom: 1.5rem;
      display: block;
      text-decoration: none;
      color: ${warmGrays[7]};
      font-family: ${serif};
      line-height: 1.375;
    }

    .SiteHeaderNav__social-link {
      margin-right: 0.375rem;
      font-size: 1rem;
    }
  }

  @media ${MQ_MIDLARGE} {
    .SiteHeaderNav__featuresBlock {
      flex: 0 1 calc(400px + 2rem);
    }

    .SiteHeaderNav__networkBlock {
    }

    .SiteHeaderNav__recirc--2 {
      display: initial;
    }
  }
`;
